import styled from "styled-components"


export const FolderStructurePage = () => {
  return (
    <StyleWrap>
      NamingConventions
    </StyleWrap>
  )
}

const StyleWrap = styled.div`

`;